import "core-js/stable";
import "classlist.js";
import "regenerator-runtime/runtime";
import RecaptchaV2 from "~/common/recaptcha_v2";
import Recaptcha from "~/common/recaptcha_v3";
import "~/common/bugsnag.js.erb";
import "~/common/ajax_setup";
RecaptchaV2.start();
Recaptcha.start();
